import websiteService from '@/services/cebeoService/modules/websiteService';

const state = {
  ambiences: [],
  stores: [],
};

const mutations = {
  SET_AMBIENCES: (state, ambiences) => {
    state.ambiences = ambiences;
  },

  SET_STORES: (state, stores) => {
    state.stores = stores;
  }
};

const getters = {
  getAmbiences() {
    return state.ambiences;
  },

  getStores() {
    return state.stores;
  }
};

const actions = {
  getAmbiences: (context) => {
    if (context.state.ambiences.length === 0) {
      websiteService.getAmbiences()
        .then((response) => {
          context.commit('SET_AMBIENCES', response.data);
        });
    }
  },

  getStores: () => {
    return new Promise((resolve, reject) => {
      websiteService.getStores()
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },

  getRegions: () => {
    return new Promise((resolve, reject) => {
      websiteService.getRegions()
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },

  getDayparts: (context, data) => {
    return new Promise((resolve, reject) => {
      websiteService.getDayparts(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },

  // eslint-disable-next-line no-empty-pattern
  createVisit: ({}, data) => {
    return new Promise((resolve, reject) => {
      websiteService.createVisit(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },

  // eslint-disable-next-line no-empty-pattern
  uploadFloorplan: ({}, {
    customerVisitId,
    file
  }) => {
    const data = new FormData();
    data.append('file', file);
    return new Promise((resolve, reject) => {
      websiteService.uploadFloorplan(customerVisitId, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
